import { ChevronRightIcon, Footer, TitleBar } from '../../../../../components';

import GenericListManager from '../../../../../components/generic/ListManager/GenericListManager';
import { FETCH_IT_APPLICATIONS } from '../../../../dataInputs/queries/itApplications';
import TitleUpdater from '../../../../../components/common/TitleUpdater';
import { UPDATE_SELECTED_IT_APPS } from './queries';
import { Button } from 'antd';
import {
  useFetchSelectedITApplications,
  useRemoveITApplicationConfirmation,
} from '../../../hooks';
import { RemoveITApplicationModal } from '../../../components/RemoveITApplicationModal';
import { useNavigate } from 'react-router';
import { FETCH_SELECTED_IT_APPS } from '../../../hooks/queries';

const EnterpriseApplications = () => {
  const navigate = useNavigate();

  const { data: applications } = useFetchSelectedITApplications();

  const {
    isModalOpen,
    affectedApplications,
    handleBeforeUpdate,
    handleConfirm,
    handleCancel,
  } = useRemoveITApplicationConfirmation(
    applications?.getSelectedItApplications ?? [],
  );

  return (
    <div>
      <TitleUpdater title="Enterprise Application Revenue Mapping" />
      <TitleBar
        title="Enterprise Application Revenue Mapping"
        subtitle={`Application Selection`}
        brief="Select which IT applications directly support revenue at the enterprise level. Exact percentages will be captured on the next page. If an IT application is missing, it needs to be added in the data inputs section."
      />
      <GenericListManager
        addedTitle="IT Applications Added"
        availableTitle="IT Applications Available"
        fetchAllQuery={{
          query: FETCH_IT_APPLICATIONS,
          identifier: 'findAllItApplications',
          variables: {
            data: {
              enterpriseWide: true,
            },
          },
        }}
        fetchSelectedQuery={{
          query: FETCH_SELECTED_IT_APPS,
          identifier: 'getSelectedItApplications',
          variables: {
            data: {
              enterpriseWide: true,
            },
          },
        }}
        refetchQueries={[
          {
            query: FETCH_SELECTED_IT_APPS,
            variables: {
              data: {
                enterpriseWide: true,
              },
            },
          },
        ]}
        itemKey="uuid"
        itemLabel="application"
        updateMutation={{
          mutation: UPDATE_SELECTED_IT_APPS,
          variableName: 'data.itApplications',
        }}
        beforeUpdate={(items) => {
          return new Promise((resolve) => {
            handleBeforeUpdate(items, () => resolve(true));
          });
        }}
      />
      <Footer
        backPath={'/cyber/enterprise-level'}
        nextPath={`/cyber/enterprise-level/it-applications/mapping`}
      />
      <RemoveITApplicationModal
        isOpen={isModalOpen}
        onCancel={handleCancel}
        onRemove={handleConfirm}
        applications={affectedApplications}
        type="Percentage"
        extendActions={
          <Button
            type="link"
            size="small"
            onClick={() =>
              navigate('/cyber/enterprise-level/it-applications/mapping')
            }
            className="group flex items-center p-0 h-auto"
          >
            <div className="flex items-center gap-4">
              View Applications
              <ChevronRightIcon
                width={8}
                height={14}
                className="group-hover:opacity-50 hover:!fill-[#437EF7]"
              />
            </div>
          </Button>
        }
      />
    </div>
  );
};

export default EnterpriseApplications;
